module.exports = __webpack_public_path__ + "img/card_icon_v1_amex.ab814ac3.svg";